import { Space } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { Icon } from '@/components/custom-icon'
import { createTourStepData } from '@/components/tour/utils'
import {
  convertPlatformShortcode,
  Platform,
  PlatformShortcode,
} from '@/utils/convert-platform'

interface PlatformSwitcherProps {
  className?: string
  /**
   * If not provided, First available platform will be used.
   */
  value?: PlatformShortcode

  onChange?: (platform: Platform) => void

  /**
   * If not provided, Facebook, YouTube and Instagram will be available.
   */
  availablePlatforms?: PlatformShortcode[]
}

const PlatformSwitcher: FunctionComponent<PlatformSwitcherProps> = ({
  className,
  value,
  onChange,
  availablePlatforms = [
    PlatformShortcode.Instagram,
    PlatformShortcode.Facebook,
    PlatformShortcode.YouTube,
  ],
}) => {
  return (
    <Space
      className={className}
      {...createTourStepData('marketing-trend', 2)}
      size={0}
    >
      {availablePlatforms.map((platformShortcode) => {
        const platform = convertPlatformShortcode(platformShortcode)
        const active = (value ?? availablePlatforms[0]) === platformShortcode

        if (!platform.icon || !platform.inactiveIcon) {
          return null
        }

        return (
          <Item
            active={active}
            key={platformShortcode}
            onClick={(): void => {
              onChange?.(platform)
            }}
          >
            <Space>
              <Icon type={active ? platform.icon : platform.inactiveIcon} />
              {active && <div>{platform.title}</div>}
            </Space>
          </Item>
        )
      })}
    </Space>
  )
}

const Item = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: ${({ theme }): string => theme.colors.text.primary};
  cursor: pointer;
  border-radius: 30px;
  padding: ${(props): string => (props.active ? '12px 20px' : '0 20px 0')};
  background-color: ${(props): string => (props.active ? '#ffffff' : 'none')};
  box-shadow: ${(props): string =>
    props.active ? '0px 2px 12px rgba(0, 0, 0, 0.102)' : 'none'};

  .anticon {
    font-size: 24px;
  }
`

export default PlatformSwitcher
